// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__GVi1-","inputDescription":"styles_inputDescription__uMSAe"};